module.exports = __webpack_public_path__ + "img/katana.737165d2.svg";